export default __webpack_public_path__ + "static/media/step1.01b54beb.webm";